module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Ini Olorunnishola","short_name":"Ini","description":"Software developer portfolio of Ini Olorunnishola.","lang":"en","start_url":"/","background_color":"#ffffff","theme_color":"#141414","display":"standalone","icon":"src/images/manifest-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"3d865a6d97ce1337eb393c8ec4902676"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
